export const roles = [
  { label: 'Διαχειριστής Κεντρικού Συστήματος', value: 'Admin' },
  { label: 'Απλός Διαχειριστής', value: 'SimpleAdmin' },
  { label: 'Ελεγκτής ΕΚΑΠΥ', value: 'AuditorEkapy' }
];

export const rolesForSearch = [
  { label: 'Διαχειριστής Κεντρικού Συστήματος', value: 'Admin' },
  { label: 'Απλός Διαχειριστής', value: 'SimpleAdmin' },
  { label: 'Ελεγκτής ΕΚΑΠΥ', value: 'AuditorEkapy' }
];

export const rolesForDialog = [
  { label: 'Διαχειριστής Κεντρικού Συστήματος', value: 'Admin' },
  { label: 'Απλός Διαχειριστής', value: 'SimpleAdmin' },
];

export const rolesForAdmin = [
  { label: 'Διαχειριστής Κεντρικού Συστήματος', value: 'Admin' },
  { label: 'Απλός Διαχειριστής', value: 'SimpleAdmin' },
  { label: 'Αιτών API', value: 'ApiRequester' },
  { label: 'Ελεγκτής ΕΚΑΠΥ', value: 'AuditorEkapy' },
];

export function setRolesForDialog() {
  rolesForDialog.splice(0, rolesForDialog.length);
  rolesForDialog.push(...rolesForAdmin);
}

export function setRolesForSearch() {
  roles.splice(0, roles.length);
  roles.push(...rolesForSearch);
}
